import React from 'react'
import { Col, Row, Tag } from 'rsuite'

interface ReadFieldProps {
  label: string
  value?: string | number | null
  suffix?: string
  xs?: number
  md?: number
  sm?: number
}

export function ReadField ({ label, value, suffix, xs = 12, md = 6, sm }: ReadFieldProps) {
  const displayValue = value != null && value !== '' ? `${value}${suffix ? ` ${suffix}` : ''}` : '—'
  return (
    <Col xs={xs} md={md} sm={sm} className="mb-3">
      <div className="text-gray-500 text-xs mb-1">{label}</div>
      <div className="text-sm font-medium">{displayValue}</div>
    </Col>
  )
}

interface ReadBoolFieldProps {
  label: string
  value?: boolean
}

export function ReadBoolField ({ label, value }: ReadBoolFieldProps) {
  return (
    <Tag color={value ? 'green' : undefined} className="mr-2 mb-2">
      {label}: {value ? 'Да' : 'Нет'}
    </Tag>
  )
}

interface ReadRowProps {
  children: React.ReactNode
  className?: string
}

export function ReadRow ({ children, className = 'mb-2' }: ReadRowProps) {
  return <Row className={className}>{children}</Row>
}
